import kapitolLogoFooter from '@/images/clients/kapitol-logo.svg'
import type { IPartnerSettings } from '.'

export const Kapitol: IPartnerSettings = {
  partner: 'Kapitol',
  deployment: 'Kapitol',
  origAppUrl: {
    development: 'https://localhost/Car.Web.Client.Kapitol',
    test: 'https://srovnavacaut.kapitol.cz/test',
    prep: '',
    production: 'https://srovnavacaut.kapitol.cz/prod',
  },
  hosts: [
    'srovnavacaut.kapitol.cz'
     //, 'localhost:44470'
  ],
  logo: kapitolLogoFooter
}
